/*
 * @Description:
 * @Author:
 * @Date: 2022-06-24 17:06:51
 * @LastEditTime: 2023-07-19 18:14:29
 * @LastEditors: dongqianqian
 * @Usage:
 */
import Vue from 'vue'
//import axios from './plugins/axios'
import App from './App.vue'
import ElementUI from "element-ui";
import * as echarts from 'echarts';
import BaiduMap from 'vue-baidu-map'

import router from './plugins/router'
import store from './store'
import "element-ui/lib/theme-chalk/index.css";
import '../src/assets/element/index.css'
import '../src/assets/base.css'
import { getStore, setStore, removeStore } from '@/util/store';
import { showMessage, showConfirm } from '@/util/promp'
import directives from '@/directives/index.js'
import { EXPORT_URL } from '@/util/constant.js';

//import jkyUtils from 'jky-utils'

// axios鉴权注册
//jkyUtils.auth.useAxiosAuth(axios, { ip: process.env.npm_config_ip })

// 自定义指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$showMessage = showMessage
Vue.prototype.$showConfirm = showConfirm
Vue.prototype.$exportPrefix = EXPORT_URL
window.getStore = getStore
window.setStore = setStore
window.removeStroe = removeStore
// setStore({ name: 'ProjectID', content: '222' })
// setStore({ name: 'companyID', content: '222' })
import i18n from './lang/config/index'
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'H3Yl0UMNYPpPt22lq6T4ixQgcytPwnKe'
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
